// extracted by mini-css-extract-plugin
export default {"v-small":"(max-width: 480px)","dialogWrapper":"submissions__dialogWrapper__TXekU"};